import { Field, Textarea } from '@chakra-ui/react';
import type { FieldProps } from './helpers';

interface EditBioProps extends FieldProps {}

const EditBio = ({ user, form }: EditBioProps) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = form;
  const maxLength = 300;
  const [value, setValue] = useState<string>(user?.bio || '');

  useEffect(() => {
    if (user?.bio) {
      setValue(user.bio);
    }
  }, [user?.bio]);

  return (
    <Field.Root invalid={!!errors.bio}>
      <Textarea
        border="none"
        background="white"
        rows={8}
        maxLength={maxLength}
        {...register('bio', {
          onChange: (e) => {
            const value = e.target.value;
            setValue(value);
          },
        })}
        placeholder={t('profile.bio')}
        _placeholder={{ color: 'fg.subtle' }}
        defaultValue={value}
      />
      <Field.HelperText as="div" w="full" textAlign="right">
        {value?.length || 0}/{maxLength}
      </Field.HelperText>
      <Field.ErrorText>{errors?.bio?.message as string}</Field.ErrorText>
    </Field.Root>
  );
};

export { EditBio };
